/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsDeleteReportDefinitionMutationResponse, AuditReportsDeleteReportDefinitionPathParams, AuditReportsDeleteReportDefinition400, AuditReportsDeleteReportDefinition401, AuditReportsDeleteReportDefinition403, AuditReportsDeleteReportDefinition404 } from "../models/AuditReportsDeleteReportDefinition";

export function getAuditReportsDeleteReportDefinitionUrl(id: AuditReportsDeleteReportDefinitionPathParams["id"]) {
  const res = { method: 'DELETE', url: `/audit-reports/v1/report-definitions/${id}` as const }
  return res
}

/**
 * @description Deletes a report definition by its unique identifier. Cannot delete if it is the only definition for the report type or if it is the default definition.
 * @summary Delete report definition
 * {@link /audit-reports/v1/report-definitions/:id}
 */
export async function auditReportsDeleteReportDefinition(id: AuditReportsDeleteReportDefinitionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsDeleteReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsDeleteReportDefinition400 | AuditReportsDeleteReportDefinition401 | AuditReportsDeleteReportDefinition403 | AuditReportsDeleteReportDefinition404>, unknown>({ method : "DELETE", url : getAuditReportsDeleteReportDefinitionUrl(id).url.toString(), ... requestConfig })
  return res.data
}